import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-a.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-a.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { ApplicationCreateService } from "../../../../create-application/shared/application-create.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { LookupConstants } from "../../../../shared/constants/lookup.constants";
import { ViewApplicationLocationAConstants } from "./view-application-location-a.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { MapTools } from "../../../../map/shared/map.tools";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { take } from "rxjs/operators";
let ViewApplicationLocationAComponent = class ViewApplicationLocationAComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    mapService;
    applicationCreateService;
    mapTools;
    requestStatusService;
    changeDetectorRefs;
    routerParamsService;
    showMap = true;
    activeTabIndex;
    advertisementsForm;
    detailsForm;
    descriptionLabel1 = ViewApplicationLocationAConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationAConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationAConstants.DESCRIPTION_LABEL_3;
    validationMessages = ViewApplicationLocationAConstants.VALIDATION_MESSAGES;
    advertisementsFormGroupName = ViewApplicationLocationAConstants.ADVERTISEMENT_FORM_GROUP_NAME;
    advertisementsFormControlName = ViewApplicationLocationAConstants.ADVERTISEMENT_FORM_CONTROL_NAME;
    areaOfDisplayFormControlName = ViewApplicationLocationAConstants.AREA_OF_DISPLAY_FORM_CONTROL_NAME;
    isAdvertisementPermanentOrTemporaryFormControlName = ViewApplicationLocationAConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationLocationAConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    typeLabel = ViewApplicationLocationAConstants.APPLICATION_TYPE_LABEL;
    streetNamesFormControl = ViewApplicationLocationAConstants.STREET_NAMES_FORM_CONTROL;
    propertyDescriptionFormControlName = ViewApplicationLocationAConstants.PROPERTY_DESCRIPTION_FORM_CONTROL_NAME;
    addressOrStreetFormControlName = ViewApplicationLocationAConstants.ADDRESS_OR_STREET_FORM_CONTROL_NAME;
    areaOfDisplayLabel = ViewApplicationLocationAConstants.AREA_OF_CONTROL_LABEL;
    streetNamesLabel = ViewApplicationLocationAConstants.STREET_NAMES_LABEL;
    propertyDescriptionLabel = ViewApplicationLocationAConstants.PROPERTY_DESCRIPTION_LABEL;
    addressOrStreetLabel = ViewApplicationLocationAConstants.ADDRESS_OR_STREET_LABEL;
    isAdvertisementPermanentOrTemporaryFormLabel = ViewApplicationLocationAConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_LABEL;
    selectedApplicationStatus;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    areaOfDisplayLookups = LookupConstants.AREA_OF_DISPLAY_LOOKUPS_A;
    showPermanentApplicationsFields = false;
    showTemporaryApplicationsFields = false;
    permanentOrTemporaryLookupOptions = LookupConstants.PERMANENT_OR_TEMPORARY_LOOKUPS_A;
    applicationTypesLookups = [];
    isMapLoaded = false;
    sketchTool;
    selectedGraphic = null;
    applicationLoaded = false;
    mapComponent;
    application;
    getApplicationsQuerySubscription;
    getLookupsObservableSubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appControllerService, mapService, applicationCreateService, mapTools, requestStatusService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.mapService = mapService;
        this.applicationCreateService = applicationCreateService;
        this.mapTools = mapTools;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.initForm();
        this.getMetadata();
    }
    ngOnInit() {
        this.getLookups();
        this.listenForRouteParamChange();
    }
    handleRouteChange() {
    }
    loadMetadata() {
    }
    ngAfterViewInit() {
    }
    listenForSelectedApplication() {
        this.selectedApplicationService.$selectedApplication.pipe(take(1)).subscribe({
            next: (application) => {
                if (application && application.id >= 0 && !this.applicationLoaded) {
                    this.getApplicationLocationDetails(application);
                    this.applicationLoaded = true;
                }
            }
        });
    }
    getApplicationLocationDetails(application) {
        const params = {
            $expand: "point, polygon",
            $filter: `jobId eq ${application.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID}`
        };
        try {
            this.getApplicationsQuerySubscription = this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe({
                next: (response) => {
                    application.point = response.value[0]?.point;
                    application.polygon = response.value[0]?.polygon;
                    this.application = application;
                    this.onGetApplicationDataCompleted(application);
                    this.applicationLoaded = true;
                }, error: (error) => {
                    this.appControllerService.handleServerErrorMessage("location details", error, CRUDOperation.Get);
                }
            });
        }
        catch (e) {
            this.requestStatusService.clearBusyRequestCounter();
        }
    }
    onGetApplicationDataCompleted(application) {
        this.getAdvertisements().clear();
        const shape = application.isAdvetisingPermanentOrTemporary.toLowerCase() === "permanent" ? application.point.shape : application.polygon.shape;
        const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(shape, 102100);
        const featureControl = this.getAdvertisements();
        const advertisingFormGroup = this.createAdvertisingFormGroup(application);
        const url = this.getGPToolURL();
        const formData = this.getGPToolFormData(geometryArc);
        this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
            next: (trueCentroidResponse) => {
                this.configureInitialAdvertisingForm(advertisingFormGroup);
                this.setTrueCentroid(advertisingFormGroup, trueCentroidResponse, featureControl);
                if (this.isMapLoaded) {
                    this.syncMapGeometries();
                }
                this.changeDetectorRefs.detectChanges();
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationLocationAConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    configureInitialAdvertisingForm(formGroup) {
        const isAdvertisingPermanentOrTemporaryValue = formGroup.get(this.isAdvertisementPermanentOrTemporaryFormControlName).value;
        if (isAdvertisingPermanentOrTemporaryValue?.toLowerCase() === "temporary") {
            this.configureFormsForTemporaryAdvertisingForm();
        }
        if (isAdvertisingPermanentOrTemporaryValue?.toLowerCase() === "permanent") {
            this.configureFormsForPermanentAdvertisingForm();
        }
    }
    createAdvertisingFormGroup(application) {
        let geometryArc;
        if (application.isAdvetisingPermanentOrTemporary.toLowerCase() === "permanent") {
            geometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.point.shape, 102100);
        }
        if (application.isAdvetisingPermanentOrTemporary.toLowerCase() === "temporary") {
            geometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.polygon.shape, 102100);
        }
        const geom = JsonUtils.fromJSON(geometryArc);
        const advertisingFormGroup = new FormGroup({
            areaOfDisplay: new FormControl({ value: application?.polygon?.areaOfDisplay, disabled: true }),
            isAdvetisingPermanentOrTemporary: new FormControl({
                value: application?.isAdvetisingPermanentOrTemporary,
                disabled: true
            }),
            streetNames: new FormControl({ value: application?.polygon?.streetNames, disabled: true }),
            streetOrAddress: new FormControl({ value: application?.polygon?.addressStreetInformation, disabled: true }),
            addressStreetInformation: new FormControl({ value: application?.point?.addressStreetInformation, disabled: true }),
            type: new FormControl({ value: application?.type, disabled: true }),
            propertyDescription: new FormControl({ value: application?.polygon?.propertyDescription, disabled: true }),
            geometry: new FormControl(geom),
            centroid: new FormControl(null, [Validators.required]),
        });
        this.advertisementsForm.get(this.isAdvertisementPermanentOrTemporaryFormControlName).setValue(application.isAdvetisingPermanentOrTemporary);
        this.advertisementsForm.disable();
        return advertisingFormGroup;
    }
    getAdvertisements() {
        return this.advertisementsForm.get(this.advertisementsFormControlName);
    }
    initForm() {
        this.advertisementsForm = this.aflaModuleStrategyService.form.get(this.advertisementsFormGroupName);
    }
    syncMapGeometries() {
        const geometries = [];
        this.getAdvertisements().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            try {
                this.mapComponent.addGeometriesOnMap(geometries, "Advertising graphics", true);
            }
            catch (e) {
                this.requestStatusService.removeBusySpinner("GetPropertyData");
            }
        }
    }
    getGPToolURL() {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        return `${proxyUrl}?${gpToolUrl}`;
    }
    getGPToolFormData(geometry) {
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometry));
        return formData;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                const lookups = response.value;
                this.onGetLookupsCompleted(lookups);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage("Lookups", error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(lookups) {
        this.applicationTypesLookups = [];
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "applicationtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.applicationTypesLookups.push(lookUpContent);
            }
        });
        this.listenForSelectedApplication();
        this.changeDetectorRefs.detectChanges();
    }
    configureFormsForTemporaryAdvertisingForm() {
        this.showTemporaryApplicationsFields = true;
    }
    configureFormsForPermanentAdvertisingForm() {
        this.showPermanentApplicationsFields = true;
    }
    setTrueCentroid(featureFormGroup, trueCentroidResponse, featureControl) {
        featureFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        featureControl.push(featureFormGroup);
        this.activeTabIndex = featureControl.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: ApplicationCreateService },
        { type: MapTools },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esriMap", { static: false },] }]
    };
};
ViewApplicationLocationAComponent = __decorate([
    Component({
        selector: "app-view-application-location-a",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationLocationAComponent);
export { ViewApplicationLocationAComponent };
